import React, { Component } from 'react';
import './App.css';
import Clients from './modules/clients';

class App extends Component {
  render = () => (<Clients />);
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js